import { render, staticRenderFns } from "./AuthorizationList.vue?vue&type=template&id=7d36d7dc"
import script from "./AuthorizationList.vue?vue&type=script&lang=js"
export * from "./AuthorizationList.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationList.vue?vue&type=style&index=0&id=7d36d7dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports